package features.booking

data class UsuarioApp(
    val uid: String,
    val nombre: String,
    val correo: String,
    val rol: String,
    val rolSolicitado: String? = null,
    val solicitadoPor: String? = null,
    val rolProgramado: String? = null,
    val fechaCambioProgramado: Long? = null
)
